module.exports = __webpack_public_path__ + "static/media/lakers.4bc96790.png";